import './GroupedNumberDisplayMax.scss';

import { AVIDataCountTileFlex } from './Layout/AVIDataCountTileFlex';
import { NumberDisplayMax } from './Charts/NumberDisplayMax';
import PropTypes from 'prop-types';
import React from 'react';

class GroupedNumberDisplayMax extends React.Component {
  static propTypes = {
    shipsByDraft: PropTypes.object,
    maxLength: PropTypes.object,
    maxBreadth: PropTypes.object,
    maxHeight: PropTypes.object,
    chartTitle: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    useFlex: PropTypes.bool
  };

  static defaulProps = {
    useFlex: false,
    chartTitle: '',
    width: 2,
    height: 0.5
  }

  render () {
    const {
      shipsByDraft,
      maxLength,
      maxBreadth,
      maxHeight,
      chartTitle,
      width,
      height,
      useFlex
    } = this.props;

    return (
      <AVIDataCountTileFlex title={chartTitle} height={height} width={width} useFlex={useFlex}>
        <NumberDisplayMax
          className='draught'
          chartTitle='Største dyptgående'
          keyName='draught'
          group={shipsByDraft}
          units='meter'
        />
        <NumberDisplayMax
          className='length'
          chartTitle='Største lengde'
          keyName='length'
          group={maxLength}
          units='meter'
        />
        <NumberDisplayMax
          className='breadth'
          chartTitle='Største bredde'
          keyName='breadth'
          group={maxBreadth}
          units='meter'
        />
        <NumberDisplayMax
          className='height'
          chartTitle='Største høyde'
          keyName='height'
          group={maxHeight}
          units='meter'
        />
      </AVIDataCountTileFlex>
    );
  }
}

export default GroupedNumberDisplayMax;
